export default __webpack_public_path__ + "static/media/키비탄.f501a44a.svg";